export default {"src":"/login-app/[GIT_HASH]/_next/static/media/memory.4e8f993e.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};